import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn";
/** Editorial surface card — soft depth, not Material elevation. */
export function Card({ children, className, hover = false, accent = false, }) {
    return (_jsx("div", { className: cn("rounded-card bg-paper-raised dark:bg-ink-soft p-6 md:p-7 shadow-card", "border border-mute-line/60 dark:border-ink-line", accent && "border-signal/40 dark:border-signal/50", hover &&
            "transition-all duration-200 hover:shadow-lift hover:-translate-y-1", className), children: children }));
}
